module.exports = __webpack_public_path__ + "img/Flag_RD2.b286d0ca.png";